import { QueryClient } from "@tanstack/react-query";

// stale-while-revalidate 캐시. 재방문 시 캐시 즉시 표시 + 백그라운드 갱신.
// 민감(돈/수령가능) 데이터는 호출부에서 staleTime을 짧게 override.
// revalidate 실패 시 React Query는 마지막 캐시를 유지(비차단).
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30000, // 일반 표시성 데이터 기본값
      gcTime: 300000,
      retry: 1,
      refetchOnWindowFocus: true, // 포커스 복귀 시 민감 데이터 최신화
      refetchOnReconnect: true,
    },
  },
});
